import { Link } from 'react-router';
import { Icon } from '@/comp/icon/icon';
import { useCallback, useContext, useMemo } from 'react';
import { AppContext } from '@/context/AppContext';
import InfoCard from '@/comp/ui/infoCard/infoCard';
import TravelTile from '@/comp/travelTile';
import { affiliate_checkIsAllowToBookService } from '@/_helper/checkAccess';
import { paymentAlertText } from '@/_data/contentText';

export const PaymentStatus = () => {
    const { bookingData, bookingState } = useContext(AppContext);

    const isServiceAllowed = useCallback((service: string) => {
        if (window.$affiliate && !affiliate_checkIsAllowToBookService(service).includes(service)) {
            return false;
        }
        return true;
    }, []);

    const isFullyPaid = useMemo(
        () => bookingData?.data.frontendParams.price.fullyPaid,
        [bookingData?.data.frontendParams.price.fullyPaid]
    );
    const isPaymentOpen = useMemo(
        () =>
            bookingState === 'OK' &&
            (bookingData?.data.allowedInteractions?.payment.deposit ||
                bookingData?.data.allowedInteractions?.payment.full),
        [
            bookingState,
            bookingData?.data.allowedInteractions?.payment.deposit,
            bookingData?.data.allowedInteractions?.payment.full,
        ]
    );

    const isPaymentRefund = useMemo(() => {
        return bookingData?.data.allowedInteractions?.payment.refund && isServiceAllowed('paymentRefund');
    }, [bookingData?.data.allowedInteractions?.payment.refund, isServiceAllowed]);

    const paymentPendingStatus = useMemo(
        () => bookingData?.data.frontendParams.paymentDetails.pending,
        [bookingData?.data.frontendParams.paymentDetails.pending]
    );

    if (!bookingData) {
        return null;
    }
    const { data } = bookingData;

    return (
        <div className="tab-content-container">
            {window.$browserInfo.device === 'mobile' && <div className="modal-mobile-background-layer"></div>}
            <div className="tab-header">
                <h3>Zahlungen</h3>
                {window.$browserInfo.device === 'mobile' && (
                    <Link rel="noopener noreferrer" className="modal-close" to={'/'}>
                        <Icon name="close" ariaLabel="overlay schließen" />
                    </Link>
                )}
            </div>
            <div className="tab-content">
                {paymentPendingStatus ? (
                    <InfoCard>
                        Danke für Ihre Zahlung. Diese befindet sich gerade in Bearbeitung. Es kann daher ein paar
                        Stunden dauern, bis die Änderungen im Kundenbereich für Sie sichtbar sind.
                    </InfoCard>
                ) : (isFullyPaid || isPaymentOpen || isPaymentRefund) &&
                  !data?.allowedInteractions?.payment?.alertFull &&
                  !data?.allowedInteractions?.payment?.alertDeposit ? (
                    <>
                        {(isFullyPaid || isPaymentOpen) &&
                            (isFullyPaid ? (
                                <TravelTile
                                    name="payment-refund-update"
                                    icon="euro"
                                    headline="Reisepreis"
                                    description="Sie haben Ihre Reise bereits komplett bezahlt."
                                    state="is-already-booked"
                                />
                            ) : (
                                <TravelTile
                                    name="payment"
                                    icon="euro"
                                    headline="Zahlung tätigen / Zahlart ändern"
                                    description="Begleichen Sie offene Zahlungen für Ihre Reise und ändern Sie optional die Zahlart."
                                    state="show"
                                    link="zahlung"
                                    linkType="internal"
                                    target="_blank"
                                />
                            ))}
                        {isPaymentRefund && (
                            <TravelTile
                                name="payment-refund-update"
                                icon="euro"
                                headline="Erstattung durchführen"
                                description="Geben Sie Ihre Bankinformationen an, um die Rückerstattung für Ihre Reise zu erhalten."
                                state="show"
                                link="rueckzahlung"
                                linkType="internal"
                                target="_blank"
                            />
                        )}
                    </>
                ) : (
                    !data?.allowedInteractions?.payment?.alertFull &&
                    !data?.allowedInteractions?.payment?.alertDeposit && <InfoCard>{paymentAlertText}</InfoCard>
                )}
                {(data.allowedInteractions.payment.alertDeposit || data.allowedInteractions.payment.alertFull) && (
                    <TravelTile
                        name="payment"
                        icon="euro"
                        headline="Zahlung überfällig"
                        description="Bitte begleichen Sie Ihre offene Zahlung zum nächstmöglichen Zeitpunkt."
                        state="alert"
                        link="zahlung"
                        linkType="internal"
                        target="_blank"
                    />
                )}
            </div>
        </div>
    );
};
